import { Grid, useMediaQuery, useTheme } from '@mui/material';
import Typography from '@mui/material/Typography';

export const StatDisplay = ({
  value,
  label,
  icon,
}: {
  value?: string | number | JSX.Element;
  label: string;
  icon: JSX.Element;
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Grid
      item
      alignItems="center"
      gap={isSmallScreen ? 0 : 1}
      display="flex"
      flexDirection={isSmallScreen ? 'column' : 'row'}>
      {icon}

      <Typography>{value}</Typography>
    </Grid>
  );
};
